import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material';
import { Auth } from 'aws-amplify';
import React from 'react';

export const HEADER_HEIGHT = 64;
export const SIDEBAR_WIDTH = 280;

const HEADER_COLORS = {
  bg: '#ffffff',
  text: '#0f172a',
  subtext: '#64748b',
  shadow: '0 1px 3px 0 rgba(0,0,0,0.08), 0 1px 2px -1px rgba(0,0,0,0.06)',
};

interface HeaderProps {
  onLogout: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onLogout }) => {
  const handleLogout = async () => {
    await Auth.signOut();
    onLogout();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        height: HEADER_HEIGHT,
        left: `${SIDEBAR_WIDTH}px`,
        width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        '@media (max-width: 800px)': {
          left: 0,
          width: '100%',
        },
        backgroundColor: HEADER_COLORS.bg,
        color: HEADER_COLORS.text,
        boxShadow: HEADER_COLORS.shadow,
        zIndex: 1300,
      }}
    >
      <Toolbar sx={{ height: HEADER_HEIGHT, minHeight: HEADER_HEIGHT, px: 3 }}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          fontFamily="'Poppins', sans-serif"
          sx={{ flexGrow: 1, color: HEADER_COLORS.text, lineHeight: 1.2, whiteSpace: 'nowrap' }}
        >
          Heka API Documentation
        </Typography>

        <IconButton
          size="small"
          onClick={handleLogout}
          sx={{ color: HEADER_COLORS.subtext, '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' } }}
        >
          <ExitToAppIcon fontSize="small" />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
